const RemoteAssistanceMainContainerStyle = `
  grid-template-areas: "calls   calls   aside";
  grid-template-columns: repeat(2, 1fr) max-content;
  grid-template-rows: max-content max-content min-content 1fr;
  width: 100%;
`;

export default RemoteAssistanceMainContainerStyle;
